<template>
  <div class="page-header-index-wide">
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
        <chart-card
          :loading="loading"
          title="销售订单数"
          :total="all.order_count"
        >
          <a-tooltip title="总销售订单数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
        <chart-card
          :loading="loading"
          title="成交笔数"
          :total="all.payed_count | NumberFormat"
        >
          <a-tooltip title="成交笔数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
        <chart-card
          :loading="loading"
          title="成交金额"
          :total="'￥' + price(all.payed_price)"
        >
          <a-tooltip title="成交金额" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
        <chart-card
          :loading="loading"
          title="复购客户"
          :total="NumberFormat(all.user_count)"
        >
          <a-tooltip title="下过订单的客户数量" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="4" :style="{ marginBottom: '20px' }">
        <chart-card
          :loading="loading"
          title="待提现收益"
          :total="NumberFormat(all.user_income)"
        >
          <a-tooltip title="待提现收益" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <a-button type="primary" @click="onDuihuan"> 兑换 </a-button>
          </div>
        </chart-card>
      </a-col>
    </a-row>

    <a-card :loading="loading" :bordered="false" :body-style="{ padding: '0' }">
      <div class="salesCard">
        <a-tabs
          default-active-key="1"
          size="large"
          :tab-bar-style="{ marginBottom: '24px', paddingLeft: '16px' }"
        >
          <a-tab-pane loading="true" tab="本月" key="1">
            <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
              <chart-card
                :loading="loading"
                title="销售订单数"
                :total="mon.order_count"
              >
                <a-tooltip title="总销售订单数" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
            <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
              <chart-card
                :loading="loading"
                title="成交笔数"
                :total="mon.payed_count | NumberFormat"
              >
                <a-tooltip title="成交笔数" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
            <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
              <chart-card
                :loading="loading"
                title="成交金额"
                :total="'￥' + price(mon.payed_price)"
              >
                <a-tooltip title="成交金额" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
            <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
              <chart-card
                :loading="loading"
                title="复购客户"
                :total="NumberFormat(mon.user_count)"
              >
                <a-tooltip title="下过订单的客户数量" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
            <a-col :sm="24" :md="12" :xl="4" :style="{ marginBottom: '20px' }">
              <chart-card
                :loading="loading"
                title="待提现收益"
                :total="NumberFormat(mon.user_income)"
              >
                <a-tooltip title="待提现收益" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
          </a-tab-pane>
          <a-tab-pane tab="本周" key="2">
            <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
              <chart-card
                :loading="loading"
                title="销售订单数"
                :total="week.order_count"
              >
                <a-tooltip title="总销售订单数" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
            <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
              <chart-card
                :loading="loading"
                title="成交笔数"
                :total="week.payed_count | NumberFormat"
              >
                <a-tooltip title="成交笔数" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
            <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
              <chart-card
                :loading="loading"
                title="成交金额"
                :total="'￥' + price(week.payed_price)"
              >
                <a-tooltip title="成交金额" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
            <a-col :sm="24" :md="12" :xl="5" :style="{ marginBottom: '24px' }">
              <chart-card
                :loading="loading"
                title="复购客户"
                :total="NumberFormat(week.user_count)"
              >
                <a-tooltip title="下过订单的客户数量" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
            <a-col :sm="24" :md="12" :xl="4" :style="{ marginBottom: '20px' }">
              <chart-card
                :loading="loading"
                title="待提现收益"
                :total="NumberFormat(week.user_income)"
              >
                <a-tooltip title="待提现收益" slot="action">
                  <a-icon type="info-circle-o" />
                </a-tooltip>
              </chart-card>
            </a-col>
          </a-tab-pane>
        </a-tabs>
        <a-row>
          <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
            <rank-list title="客户名&金额" :list="rankList" />
          </a-col>
        </a-row>
      </div>
    </a-card>
  </div>
</template>

<script>
import { analysisOrderIndexData } from "@/api/analysis";
import ChartCard from "@/components/chart/ChartCard";
import ACol from "ant-design-vue/es/grid/Col";
import ATooltip from "ant-design-vue/es/tooltip/Tooltip";
import MiniArea from "@/components/chart/MiniArea";
import MiniBar from "@/components/chart/MiniBar";
import MiniProgress from "@/components/chart/MiniProgress";
import RankList from "@/components/chart/RankList";
import Bar from "@/components/chart/Bar";
import Trend from "@/components/Trend";

export default {
  name: "Analysis",
  components: {
    ATooltip,
    ACol,
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    RankList,
    Bar,
    Trend,
  },
  data() {
    return {
      loading: true,
      all: {
        order_count: 0,
        payed_count: 0,
        payed_price: 0,
        user_count: 0,
      },
      mon: {
        order_count: 0,
        payed_count: 0,
        payed_price: 0,
        user_count: 0,
      },
      week: {
        order_count: 0,
        payed_count: 0,
        payed_price: 0,
        user_count: 0,
      },

      rankList: [
        {
          name: "张三",
          total: "212元",
        },
        {
          name: "张三",
          total: "212元",
        },
        {
          name: "张三",
          total: "212元",
        },
      ],
    };
  },
  created() {
    let that = this;
    setTimeout(() => {
      this.loading = !this.loading;
    }, 1000);

    analysisOrderIndexData().then((res) => {
      this.all = res.data.all;
      this.mon = res.data.mon;
      this.week = res.data.week;
      that.rankList = res.data.list;
    });
  },
  methods: {
    onDuihuan(){
      // const {href} = this.$router.resolve({name:'WithdrawalList'});
      this.$router.push({name:'WithdrawalList'})
            // window.open(href, '');
    },
    NumberFormat(value) {
      if (!value) {
        return "0";
      }
      const intPartFormat = value
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); //将整数部分逢三一断
      return intPartFormat;
    },
    price(data) {
      if (data != null) {
        return (data / 100)
          .toFixed(2)
          .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
      } else {
        return 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}
</style>